module.exports = __webpack_public_path__ + "static/media/logo.6583da28.png";